import './ModalImages.scss';
import React, {useState, useEffect} from "react";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage";
import Modal from "../../../shared/component/Modal/Modal";
import TextBox from "../../../shared/component/textbox/Textbox";
import { default as _ } from '../../../helpers/Translate';
import ComboBox from "../../../shared/component/ComboBox/ComboBox2";

export default function ModalImages(props) {
    const [language] = useState(Storage.getLanguage())
    const [modalShow, setModalShow] = useState(props.show);
    const [images, setImages] = useState(props.images);
    const [selecteds, setSelecteds] = useState([]);
    const [viewImageHere, setViewImageHere] = useState(null);
    const [editor] = useState(props.editor);
    const [target, setTarget] = useState(null);

    useEffect(() => {
    }, []);


    useEffect(() => {
        resetImages()
        loadModalAsReport()
    }, [props.images, props.editor]);

    const resetImages = () => {
        let t = images
        for (let i=0; i< t.length; i++){
            t[i]={...t[i], "selected" : false, "description": ""}
        }
        setImages(t)
        setSelecteds([])
    };

    const imageView = (item, event) => {
        event.currentTarget.style.border = '1px solid #FEC200'
        setTarget(event.currentTarget)
        setViewImageHere(item)
    };

    const imageViewOut = (event) => {
        if (target) {
            target.style.border = '1px solid #ffffff'
        }
        event.currentTarget.style.border = '1px solid #ffffff'

        setTarget(null)
        setViewImageHere(null)
    };

    const Fields = (item, field, value) => {
        setImages(prevImages => {
            const t = prevImages.map(img => {
                if (img.imgSeriesFileID === item.imgSeriesFileID) {
                    if (field === 'selected' && value === true) {
                        return { ...img, [`${field}`]: value, "description": item?.description || "" };
                    } else {
                        return { ...img, [`${field}`]: value };
                    }
                } else {
                    return img;
                }
            });
            return t;
        });
        const found = selecteds.map(element => element.imgSeriesFileID === item.imgSeriesFileID).indexOf(true);
        if (found === -1 ) {
            if (field === 'selected' && value === true) {
                setSelecteds(prevSelecteds => { return [...prevSelecteds, item]} );
            }
        } else {
            setSelecteds(prevSelecteds => {
                const t = prevSelecteds.map(sel => {
                    if (sel.imgSeriesFileID === item.imgSeriesFileID) {
                        return { ...sel, [`${field}`]: value };
                    } else {
                        return sel;
                    }
                });
                return t;
            });
        }
    };

    const addToSlected = (item, event = null) => {
        Fields(item, 'selected', true)
    }

    const crossClicked = (item, e) => {
        Fields(item, 'selected', false)
        setSelecteds(selecteds.filter(items => items.imgSeriesFileID !== item.imgSeriesFileID))
        setTarget(null)
        setViewImageHere(null)
    }

    const selectedsClick = (item, event) => {
        if (event.detail === 2 && event.target.tagName.toUpperCase() !== "INPUT") {
            crossClicked(item, null)
        }
    }

    const description = (item, event) => {
        Fields(item, 'description', event)
    }

    const checkClicked = (item, event) => {
        crossClicked(item, null)
    }

    const syncImagesAndSelecteds = (imgs = images) => {
        let s = imgs.filter(element => element.selected === true)
        s.map(element => addToSlected(element))
    }

    const handleAddToFindings = () => {
        try {
            if ((selecteds.length >= 0) && editor?.current?.getInstance()) {
                let table = "\n" + makeTable() + "\n"
                editor.current.getInstance().changeMode("markdown")
                editor.current.getInstance().moveCursorToEnd()
                let end = editor.current.getInstance().getSelection()
                let findingsWhole = editor.current.getInstance().getSelectedText([1, 1], end[0]).toString()
                let reportTable = sendStringGetTableWithRegEx(findingsWhole)
                if (reportTable?.length) {
                    findingsWhole = findingsWhole.replace(reportTable , table)
                    editor.current.getInstance().deleteSelection([1, 1], end[0])
                    editor.current.getInstance().insertText(findingsWhole)
                } else {
                    editor.current.getInstance().moveCursorToEnd()
                    editor.current.getInstance().insertText(table)
                }
                editor.current.getInstance().changeMode("wysiwyg")
                editor.current.getInstance().moveCursorToEnd()
                editor.current.getInstance().insertText(`\n`)
            }
            setModalShow(false);
            onClose()
        } catch {
            editor.current.getInstance().changeMode("wysiwyg")
            setModalShow(false);
            onClose()
            console.log("error on insert table in handling add to finding")
        }
    }
	
	const handleWidth = () => {
		let len = selecteds.length
		if (len <= 6)
			return [Math.min(3, selecteds.length)]
		else return [4]

	}
	

    const makeTable = () => {
        if (selecteds.length === 0 ) return "";
        let [n, width = null] = handleWidth();
        let table = `|${Array(n + 1).join('|')}\n|${Array(n + 1).join(':---:|')} \n`;
        for (let i = 0; i < selecteds.length; i = i + n) {
            let m = "|"
            let d = "|"
            for (let j = 0; j < n; j++) {
                if (selecteds[i + j]) {
                    m = m + `${i + j + 1} ![${selecteds[i + j].imgSeriesFileID}](${selecteds[i + j].imgSeriesFileLink}${width ? `?width=${width}` : ''}) |`
                    d += `${selecteds[i + j].description || '-'}|`
                }
            }
            table += m + "\n" + d + "\n"
        }
        return table
    }

    const sendStringGetTableWithRegEx = (str) => {
        const tableRegex = /(\|.*\|\r?\n)+/g; // Regular expression to match tables
        let match;
        while ((match = tableRegex.exec(str)) !== null) {
            const tableString = match[0];
            if (tableString.includes('/image/')) {
                const startIndex = match.index;
                const endIndex = startIndex + tableString.length;
                return str.slice(startIndex, endIndex)
            }
        }
    }

    const loadModalAsReport = () => {
        let str = editor?.current?.getInstance().getMarkdown() || ""

        let table = sendStringGetTableWithRegEx(str) || []
        if (table.length) {
            let imags = senTableGetImgMarkdowns(table)[0] || []
            let texts = []
            let ids = []
            if (imags.length) {
                let text = table.slice(senTableGetImgMarkdowns(table)[1]).split("|")
                texts = sendTableGetDescriptions(text)
                imags.forEach(element => {
                    let t = sendImgGetImgAlts(element)
                    ids.push((t[0].slice(1, -1)))
                });
                seperateSelectedsAndAllPics(ids, texts)
            }
        }
    }

    const senTableGetImgMarkdowns = (tbl) => {
        const re4 = /!\[(.*?)\]\((.*?)\)/g;
        return [tbl.match(re4), tbl.search(re4)]
    }

    const sendImgGetImgAlts = (img) => {
        const re5 = /\[(.*?)\]/g;
        return img.match(re5)
    }
    const sendTableGetDescriptions = (tbl) => {
        let decs = []
        for (let i = 0; i < tbl.length; i++) {
            if (tbl[i] !== "\n" && tbl[i] !== "" && !tbl[i].includes("image/")) {
                decs.push(tbl[i])
            }
        }
        return decs
    }

    const seperateSelectedsAndAllPics = (ids = null, texts = null) => {
        let t = images
        if (ids && ids.length <= texts.length) {
            let j = 0
            for (let i = 0; i < t.length; i++) {
                ids.forEach(element => {
                    if (t[i].imgSeriesFileID === element) {
                        t[i] = { ...t[i], "description": texts[j], "selected": true }
                        j = j + 1
                    }
                });
            }
        }
        setImages(t)
        syncImagesAndSelecteds(images)
    }

    const onClose=()=>{
        props.onClose()
    }

    return (
        <>
            <Modal className="ModalImages"
                show={modalShow}
                closeModal={() => onClose()}
                title='select_pictures'
                closeable={false}
            >
                <div className={''}>
                    <hr />

                    <div className={'__header'}>
                    </div>
                    <div className={'__body'} >
                        <div className='middle'>
                            <div className='__title'>
                                <T token={'total_pictures'} />
                            </div>
                            <div id="AllPics" className='AllPics' >
                                {
                                    images?.length === 0 ? <div style={{ color: "red" }}>All images are selected</div>
                                        :
                                        images && images.map((item, index) => {
                                            return <div className={`AllPicsWhole ${item.selected ? "selected" : ""}`} key={index}>
                                                <i className="checkBtn fal fa fa-check-square" onClick={(e) => { checkClicked(item, e) }} />
                                                <img alt=""
                                                    loading="lazy"
                                                    id={`AllPicsIMG-${item.imgSeriesFileID}`}
                                                    src={`${item.imgSeriesFileLink}?width=64`}
                                                    onClick={(event) => addToSlected(item, event)}
                                                    onMouseOver={(event) => imageView(item, event)}
                                                    onMouseOut={(event) => imageViewOut(event)}
                                                />
                                            </div>
                                        })
                                }
                            </div>
                        </div>

                        <hr />

                        <div className='downs' >
                            <div className="selecteds" >
                                <div className='titleSizeReset'>
                                    <div className={"__title"}>
                                        <T token={'selected_item'} />
                                    </div>

                                    <div className={"reset_finding_buttons"} >
                                        <div className={'reset'}
                                             onClick={()=> resetImages()}
                                             title={_.init("remove_selected_images_and_description",language)}
                                        >
                                            <i className={'fal fa-refresh'} />
                                        </div>
                                        <div className={'loadFromEditor'}
                                             onClick={()=> loadModalAsReport()}
                                             title={_.init("load_images_from_editor",language)}
                                        >
                                            <i className={'fal fa-file-image'} />
                                        </div>
                                    </div>
                                </div>
                                <div className='SelectedPics'>
                                    {selecteds.map((item, index) => (
                                        <div className='selectedWhole'
                                            id={`SelectedPicsIMG-${item.imgSeriesFileID}`}
                                            key={index}
                                            onMouseOver={(event) => imageView(item, event)}
                                            onMouseOut={(event) => imageViewOut(event)}
                                            onClick={(event) => selectedsClick(item, event)}
                                        >
                                            <i className="closeBtn fal fa-times-circle" onClick={(e) => { crossClicked(item, e) }} />
                                            <img alt=""
                                                src={`${item.imgSeriesFileLink}?width=90`}
                                            />
                                            <TextBox
                                                changeValue={(e) => description(item, e.target.value)}
                                                value={item.description}
                                                placeholder={_.init(`image_report_description`)}
                                                isAutoFocus={true}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='buttons'>
                            </div>

                            <div className='view'>
                                <div className='__title'>
                                    <T token={'preview_picture'} />
                                </div>
                                {viewImageHere &&
                                    <figure id="ImageHere">
                                        <img id=""
                                            src={`${viewImageHere.imgSeriesFileLink}`}
                                        />
                                    </figure>
                                }
                            </div>
                        </div>
                        <div className={'imodal__action'}>
                            <div className={'imodal__btn imodal__btn--primary'}
                                onClick={() => handleAddToFindings()}
                            >
                                <T token={'apply_changes'} />
                            </div>
                            <div className={'imodal__btn imodal__btn--secondary'}
                                onClick={() => onClose()}
                            >
                                <T token={'cancel'} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
};




// TODO: is it target Needed or it is for last Mode with select?